export default __webpack_public_path__ + "static/media/Silk-Serif-Regular.0d882e18.otf";